import PropTypes from 'prop-types';

export default function DataGridRow({ children }) {
  return <tr>{children}</tr>;
}

DataGridRow.propTypes = {
  children: PropTypes.node,
};
